module.exports = __webpack_public_path__ + "img/circle-unactive.bdb7b2ad.svg";